import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import tinycolor from 'tinycolor2';

import { Link, DiButton } from '../DiComponents';

import AddToCalendarLink from './AddToCalendarLink';

const ListLink = styled(Link)(
  ({ theme }) => css`
    display: block;
    width: 100%;
    padding: ${theme.space.xs} ${theme.space.sm};
    color: ${theme.colors.black};

    &:hover {
      color: ${theme.colors.black};
      background-color: ${tinycolor(theme.colors.blue).lighten(20).toHexString()};
      text-decoration: none !important;
    }
  `
);

const popoverProps = {
  backgroundColor: 'inputBackground',
};

export default function DiAddToCalendarLink({ useLink = false, ...props }) {
  return (
    <AddToCalendarLink
      ListLink={ListLink}
      Link={useLink ? Link : DiButton}
      popoverProps={popoverProps}
      {...props}
    />
  );
}
